import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface TimeSlot {
  start_utc: string; // ISO string in UTC
  end_utc: string;   // ISO string in UTC
  provider_timezone: string;
}

export interface WeekdayPlanning {
  [key: string]: TimeSlot[];
}

export interface Planning {
  weekdays: WeekdayPlanning;
  timezone: string;
}

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  /**
   * Get global planning for the current user
   */
  public getGlobalPlanning(): Observable<Planning> {
    return this.http.get<Planning>(`${environment.apiUrl}/manage/calendar`);
  }

  /**
   * Get available time slots for a service on a specific date
   */
  public getAvailableTimeSlots(
    serviceId: number,
    date: Date
  ): Observable<{ date: string; weekday: string; timeSlots: TimeSlot[] }> {
    const dateString = date.toISOString().split('T')[0];
    return this.http.get<{ date: string; weekday: string; timeSlots: TimeSlot[] }>(
      `${environment.apiUrl}/marketplace/planning/service/${serviceId}/available-slots?date=${dateString}`
    );
  }

  /**
   * Add a timeslot to a specific day in the global planning
   */
  public addTimeslotToDay(day: string, timeslot: {start: string, end: string}): Observable<Planning> {
    return this.http.post<Planning>(`${environment.apiUrl}/manage/calendar/timeslot`, {
      day,
      timeslot
    });
  }

  /**
   * Delete a timeslot from a specific day in the global planning
   */
  public deleteTimeslotFromDay(day: string, timeslot: TimeSlot): Observable<Planning> {
    return this.http.request<Planning>('delete', `${environment.apiUrl}/manage/calendar/timeslot`, {
      body: { day, timeslot }
    });
  }
}
